export default __webpack_public_path__ + "static/Plots0108-002ba3ff4b0f1a742d72ca3b793ca5d8.jpg";